module.exports = __webpack_public_path__ + "media/konrad_beeildich.52945b6a.mp3";